import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RvpTestPattern from '../components/RvpTestPattern';

/**
 * Page standalone : mire de test vidéoprojecteur.
 * Ouverte via window.open() depuis RvpLandingPage pour permettre au formateur
 * de valider la config du projecteur AVANT l'arrivée des élèves & parents.
 */
export default function RvpMirePage() {
  const nav = useNavigate();

  useEffect(() => {
    document.title = 'Mire de test projecteur · Code Voiture';
  }, []);

  return (
    <RvpTestPattern
      onClose={() => {
        // Si ouverte dans un popup, on ferme la fenêtre. Sinon on revient à la landing.
        try {
          if (window.opener) window.close();
          else nav('/enseignant/rendez-vous-pedagogiques');
        } catch {
          nav('/enseignant/rendez-vous-pedagogiques');
        }
      }}
    />
  );
}
